import { useHits } from "react-instantsearch"
import { makeStyles } from "tss-react/mui"
import { Link } from "component-lib/Base"

const useStyles = makeStyles()((theme) => ({
  query: {
    "&:focus, &:hover, &.btn:focus, &.btn:hover": {
      background: `${theme.palette.background.greenHover} !important`,
      textDecoration: "underline",
      textDecorationColor: `${theme.palette.background.greenUnderline} !important`,
    },
  },
}))

const Query = ({ hit, sendEvent, languageRoute }) => {
  const { classes } = useStyles()
  if (!hit) {
    return null
  }

  return (
    <Link
      className={`wm-grey-light px-3 pt-3 w-100 underline-focus ${classes.query}`}
      href={`${languageRoute}/search?q=${(encodeURIComponent, hit.query)}`}
      isExternalLink
      onClick={() => {
        sendEvent("click", hit, "Query Clicked")
      }}
      data-testid="QueryLink"
    >
      <div
        className="px-3 pb-3 maax-font-weight-bold wm-border-bottom"
        data-testid="Query"
      >
        {hit.query}
      </div>
    </Link>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// Query.propTypes = {
//   hit: PropTypes.object.isRequired,
//   sendEvent: PropTypes.func.isRequired,
//   languageRoute: PropTypes.string.isRequired,
// }

const Queries = (props) => {
  const propsWithDefaults = {
    ...props,
    isPreSearch: props.isPreSearch || false,
  }
  const { indexName, isPreSearch, languageRoute } = propsWithDefaults
  const { hits, sendEvent } = useHits(propsWithDefaults)

  if (isPreSearch) {
    return null
  }

  return hits.map((hit, index) => (
    <Query
      key={`${indexName}-${index}`}
      hit={hit}
      sendEvent={sendEvent}
      languageRoute={languageRoute}
    />
  ))
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// Queries.propTypes = {
//   indexName: PropTypes.string.isRequired,
//   languageRoute: PropTypes.string.isRequired,
//   isPreSearch: PropTypes.bool,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// Queries.defaultProps = {
//   isPreSearch: false,
// }

export { Query }

export default Queries
